<template>
  <div id="order-detail">
    <!-- <div class="box order-header" v-if="orderDetail.id">
      <div :class="[hunbol?'hun-image-container':'order-image-container']">
        <img :src="headImageUrl" alt="order-image">
      </div>

      <div class="order-info">
        <div class="info-line">
          <div class="spec-name">{{orderDetail['description']}}</div>
          <div class="order-status">{{orderStates[orderDetail['state']]}}</div>
        </div>

        <button class="btn btn-small save-btn"
                @click="showPopup(true)"
                v-if="canSave">保存电子照</button>
      </div>
    </div> -->
    <div class="box" v-if="orderDetail.id">
        <div class="top">
            证件照信息
            <div class="topr">{{orderStates[orderDetail['state']]}}</div>
        </div>
        <div class="middle">
            <oditem :img="headImageUrl" :hunbol="hunbol" :specName="orderDetail['description']" :quantity='orderDetail["quantity"]' :price="orderDetail['price']"></oditem>
        </div>
        <div class="bottom" v-if="orderDetail.append_orders.length>0">
            <p class="btitle">加印照片</p>
            <div class="blistwrap" v-for="item in orderDetail.append_orders" :key="item.id">
                <oditem :img="item.single_url" :hunbol="hunbol" :specName="item.spec_name+'（'+item.color+'）'" :quantity='item.quantity' :price="item.price"></oditem>
            </div>
        </div>
    </div>
    <div class="box" v-if="orderDetail.id">
      <div class="card-title">订单信息</div>
      <div class="card-body">
        <div class="card-item card-item-with-button">
          <span class="left">订单编号 : {{orderDetail['order_no']}}</span>
          <button class="btn btn-small cp-btn clip-btn orderCopy"
                  @click="copyFn(orderDetail['order_no'],'orderCopy')()">复制
          </button>
        </div>
        <div class="card-item" v-if="orderDetail['state']==='waiting'">下单时间: {{orderTime}}</div>
        <div class="card-item" v-else>付款时间: {{payedTime}}</div>
        <div class="card-item">冲印版数: {{orderDetail['total_quantity']}}</div>
        <div class="card-item" v-if="orderDetail['formal_wear_price']">个性换正装 : ¥{{(orderDetail['formal_wear_price']/100).toFixed(2)}}</div>
        <template v-if="!isMerge">
        <div class="card-item">总价：¥{{(orderDetail['price_total']/100).toFixed(2)}}</div>
        <!-- <div class="card-item"
             v-show="orderDetail['preferential_description']"
             style="justify-content: flex-start;">
          {{orderDetail['preferential_description']}}：<span style="color: #F63D30">-¥{{(orderDetail['discount_amount']/100).toFixed(2)}}</span></div> -->
        <div class="card-item"
                        v-for="item in orderDetail['discounts']"
                        :key="item.name"
                        style="justify-content: flex-start;">
                      {{item.name}} ：<span style="color: #F63D30">-¥{{(item.price/100).toFixed(2)}}</span>
                  </div>
        <div class="card-item" v-show="orderDetail['actual_amount_paid']">
          {{orderDetail['state'] === 'waiting' ?  '应付：' : '实付：'}}¥{{(orderDetail['actual_amount_paid']/100).toFixed(2)}}
          <span style="color: #F63D30;opacity:0.5" v-show="orderDetail['discount_amount']">（已优惠¥{{(orderDetail['discount_amount']/100).toFixed(2)}}）</span>
        </div>
        </template>
      </div>
    </div>
    <div class="box" v-if="orderDetail.id">
      <div class="card-title">收货人信息</div>
      <div class="card-body">
        <div class="card-item">收货人：{{orderDetail['user_name']}}</div>
        <div class="card-item">联系电话：{{orderDetail['user_phone']}}</div>
        <div class="card-item" style="align-items: flex-start;justify-content: flex-start;"
             v-if="orderDetail['user_address']">
          <div class="_left">收货地址：</div>
          <div class="_right" style="word-break: break-all;">{{orderDetail['user_address'].replace(/(\s)*\/(\s*)/g, '')}}</div>
        </div>
      </div>
    </div>
    <div class="box" id="packageTrackInfo" style="margin-bottom: 0;">
      <div class="card-title card-title-blue">快递信息</div>
      <div class="card-body">
        <div v-if="orderDetail['express_no']">
          <div class="card-item">配送方式：{{orderDeliveries[orderDetail['delivery']]}}</div>
          <div class="card-item">快递公司：{{orderDetail['express_service']}}</div>
          <div class="card-item">
            <span class="_left">快递单号：{{orderDetail['express_no']}}</span>
            <div class="_right">
              <button class="btn btn-small cp-btn clip-btn kuaino"
                      @click="copyFn(orderDetail['express_no'],'kuaino')()">复制
              </button>
            </div>
          </div>
          <template v-if="expressLog && expressLog.length">
            <div id="package-info-detail">
              <div class="package-info-item" v-for="(item, index) in expressLog" :key="index + item.time">
                <div class="package-datetime">
                  <div class="package-time">{{item.time}}</div>
                  <div class="package-date">{{item.date}}</div>
                </div>
                <div class="package-content-container">
                  <div class="package-content">{{item.status}}</div>
                </div>
              </div>
            </div>
            <div style="text-align: center;padding-bottom: 25px;">
              <div class="shipping-tip">本信息由快递公司提供，本应用仅提供展示</div>
            </div>
          </template>
          <div style="text-align: center;padding-bottom: 25px;" v-else>
            <div class="shipping-tip">暂无快递信息</div>
          </div>
        </div>
        <div style="text-align: center;padding: 15px 0;" v-else>
          <div class="shipping-tip">暂无快递信息</div>
        </div>
      </div>
    </div>

    <div style="height: 60px;width: 100%;"></div>

    <mt-popup v-model="popupVisible"
              :modalFade="true"
              :lock-scroll="true"
              popup-transition="popup-fade"
              :closeOnClickModal="true"
              :modal="true">

      <div class="popup-box" :class="{'is-send-email': isSendMail}">
        <div class="popup-box-header">
          <div class="_title">保存电子照</div>
          <button class="btn _close" @click="showPopup(false)">
            <icon-cross/>
          </button>
        </div>
        <div class="popup-box-container">
          <div class="btn-groups">
            <button class="action-btn btn-copy"
                    :class="{'active': !isSendMail}"
                    @click="isSendMail=false">
              <icon-key :color="isSendMail?'#8D99FF':'#394BE5'"/>
              提取码
            </button>
            <button class="action-btn btn-email"
                    :class="{'active': isSendMail}"
                    @click="isSendMail=true">
              <icon-mail :color="isSendMail?'#394BE5':'#8D99FF'"/>
              发送到邮箱
            </button>
          </div>
          <div class="tip-row">
            <span class="_brick" :class="{'_brick-email': isSendMail}"></span>
            {{popupTxt.tip}}
          </div>
          <div class="input-row">
            <template v-if="!isSendMail">
              <div class="_row">
                <span class="_key">下载地址</span>
                <span class="_value">www.id-photo-verify.com/t2</span>
              </div>
              <div class="_row">
                <span class="_key">提取码</span>
                <span class="_value">{{orderDetail['extract_code']}}</span>
              </div>
            </template>
            <template v-else>
              <div class="_row _big">
                <span class="_key" style="flex-shrink: 0;">电子邮箱</span>
                <input type="email" style="width: 100%;border: 0;outline:none;line-height:1.5em;" placeholder="请输入您的邮箱" v-model="emailAddr">
              </div>
            </template>
          </div>
        </div>
        <div class="popup-box-footer">
          <button id="copyBtn"
                  :data-clipboard-text="copyBtnClipboardTxt"
                  style="display: none"></button>
          <button class="clip-btn confirm-btn"
                  @click="handleConfirm">{{popupTxt.comfirm}}
          </button>
        </div>
      </div>
    </mt-popup>
    <div class="savebtnp"  @click="showPopup(true)" v-if="canSave">保存电子照</div>
  </div>
</template>

<script>
  import Moment from 'moment'
  import {mapActions} from 'vuex'
  import {ORDER_DELIVERY, ORDER_STATE} from '../utils/const'
  import ClipboardJS from 'clipboard'
  import {Popup, Toast} from 'mint-ui'
  import IconKey from "../components/Icon/IconKey"
  import IconMail from "../components/Icon/IconMail"
  import IconCross from "../components/Icon/IconCross"
  import oditem from "@/components/oditem"
  export default {
    components: {IconCross, IconMail, IconKey,oditem, [Popup.name]: Popup},
    data() {
      return {
        popupVisible: false,
        isSendMail: false,
        emailAddr: '',
        clipboard: null,
        orderId: this.$route.params.order_id,
        isLoadingDetail: false,
        orderDetail: {},
        orderStates: ORDER_STATE,
        orderDeliveries: ORDER_DELIVERY,
        expressLog: null,
        isMerge: false,
        pattern: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
      };
    },

    methods: {
      ...mapActions(['getOrderDetailAndLog','sendPrintEmail']),
      showPopup(isShow = true) {
        this.popupVisible = isShow
      },
      copyFn(no,classElem){
        let obj = null;
        return function(){
          console.log('lalala')
          obj = obj?obj:new ClipboardJS('.'+classElem,{
            text: function() {
              return no;
            }
          });
          console.log(obj)
          obj.on('success', e => {
            console.log(`${e.action} success! value is: \n${e.text}`);
            Toast('已复制到剪贴板')
          })
        }
      },
      handleConfirm() {
        if (this.isSendMail) { // send email
          if (!this.emailAddr) return Toast('请填写邮箱！')
          this.emailAddr = this.emailAddr.trim()
          console.log('this.emailAddr:::',this.emailAddr)
          var regQq = /^[1-9]\d+@qq\.com$/;
          var regq = /@qq\.com$/
          if (!this.pattern.test(this.emailAddr)||((regq.test(this.emailAddr)&&!regQq.test(this.emailAddr))
)) return Toast('邮箱格式不正确！')
          this.sendPrintEmail({orderId:this.orderDetail.id, email:this.emailAddr})
            .then(({data}) => {
              setTimeout(() => {
                if (+data.remaining_number)
                  Toast(`发送成功！本订单还可以发送${data.remaining_number}次~`)
                else
                  Toast(`发送成功！本订单无剩余次数。`)
              }, 400)
              this.showPopup(false)
              this.$set(this, 'emailAddr', '')
            })
            .catch(err => {
              this.showPopup(false)
              this.$set(this, 'emailAddr', '')
            })
        } else { // copy
          let clipboardExtract = new ClipboardJS('#copyBtn')
          clipboardExtract.on('success', e => {
            this.showPopup(false)
            console.log(`${e.action} success! value is: \n${e.text}`);
            setTimeout(() => {
              Toast('已复制到剪贴板')
            }, 400)
          })

          document.querySelector('#copyBtn').click()
          clipboardExtract.destroy();
        }
      },

      // getOrderDetail(orderId) {
      //   return getOrderDetail(orderId)
      //     .then(({data}) => {
      //       console.log(data)
      //       this.orderDetail = data
      //     })
      // },
    },

    activated() {
      let ths = this;
      this.orderId=this.$route.params.order_id;
      this.isMerge = !!this.$route.query.isMerge;
      // this.getOrderDetail(this.orderId)
      //   .catch(() => {
      //     this.$router.go(-1)
      //   })
      this.getOrderDetailAndLog({orderId:ths.orderId}).then(res => {
        console.log(res);
        this.orderDetail = res[0].data;
        let {data} = res[1];
        const expressLogList = data.reduce((arr, curr, currIndex, totalArray) => {
              const currDate = curr.time;

              arr.push({
                time: Moment(currDate).format('HH:mm'),
                date: Moment(currDate).format('YYYY-MM-DD'),
                status: curr.status
              })

              return arr
            }, [])

            this.expressLog = [...expressLogList];
      })
    },

    beforeDestroy() {
      this.clipboard && this.clipboard.destroy()
    },
    deactivated() {
      this.clipboard && this.clipboard.destroy()
    },

    computed: {
      hunbol() {
        return this.orderDetail.extra && (this.orderDetail.extra.type==='marriage' || this.orderDetail.extra.phototype==='marriage')
      },
      canSave() {
        return this.orderDetail['state']=='shipping'
            || this.orderDetail['state']=='completed'
            || this.orderDetail['state']=='processing'
      },

      isLoading() {
        return this.isLoadingDetail
      },

      popupTxt() {
        return !this.isSendMail ? {
          comfirm: '复制地址及提取码',
          tip: '请在“电脑浏览器”中打开网址提取证件照'
        } : {
          comfirm: '发送至指定邮箱',
          tip: '请在下方输入您的邮箱，每单最多可以发送3次~'
        }
      },

      copyBtnClipboardTxt() {
        return `下载地址: www.id-photo-verify.com/t2\n提取码: ${this.orderDetail['extract_code']}`
      },

      orderTime() {
        let {created_at} = this.orderDetail
        if (created_at)
          return Moment(created_at).format('YYYY-MM-DD HH:mm:ss')
        return ''
      },

      payedTime() {
        let {paid_at} = this.orderDetail
        if (paid_at)
          return Moment(paid_at).format('YYYY-MM-DD HH:mm:ss')
        return ''
      },

      headImageUrl() {
        let {image_urls} = this.orderDetail
        if (image_urls) return image_urls.single

        return ''
      }
    }
  };
</script>


<style>
  .mint-toast {
    z-index: 2100!important;
  }
</style>


<style lang="scss" scoped>
  .top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: .14rem;
        color:#363636;
        font-weight: bold;
        height:.38rem;
        box-sizing: border-box;
        padding:0 .16rem;
        border-bottom: 0.5px solid rgba(151, 151, 151, 0.3);
        margin-bottom: .29rem;
    }
    .topr{
        color:#394BE5;
    }
    .middle{
        box-sizing:border-box;
        padding:0 .16rem .16rem;
    }
    .bottom{
        margin:.14rem .16rem;
        .btitle{
            font-size:.12rem;
            color:rgba(54, 54, 54, 0.5);
        }
        .blistwrap{
            margin-top:.08rem;
            box-sizing:border-box;
            padding:.16rem;
            background-color:#F8FAFE;
        }
    }
  button {
    outline: none;
    padding: 0;
    padding-top: 2px;
  }

  .mint-popup {
    background-color: transparent;
  }

  .popup-box {
    width: 3.27rem;
    height: 2.95rem;
    background-color: #fff;
    border-radius: 0.09rem;
    transition: height 300ms ease-in-out;

    &.is-send-email {
      height: 2.75rem;
    }

    .popup-box-header {
      text-align: center;
      position: relative;
      font-size: 0.16rem;
      padding-top: 0.13rem;
      margin-bottom: 0.25rem;

      ._close {
        position: absolute;
        top: 0.06rem;
        right: 0.07rem;
        width: 0.25rem;
        height: 0.25rem;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
      }
    }

    .popup-box-footer {
      text-align: center;
      padding: 0.16rem 0;

      .confirm-btn {
        width: 1.98rem;
        height: 0.34rem;
        background-color: rgba(57, 75, 229, 1);
        border-radius: 0.04rem;
        color: #fff;
        border: 0;
        outline: none;
      }
    }

    .popup-box-container {
      width: 100%;
      overflow: hidden;

      .btn-groups {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .action-btn {
        border: 1.5px solid #8D99FF;
        color: #8D99FF;
        background-color: transparent;
        width: 1.24rem;
        height: 0.34rem;
        border-radius: 0.2rem;
        transition: color 200ms;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        & + .action-btn {
          margin-left: 0.35rem;
        }

        &.active {
          border-color: #394BE5;
          color: #394BE5;
        }
      }

      .tip-row {
        height: 0.34rem;
        margin-top: 0.11rem;
        background-color: rgba(221, 232, 255, 1);
        line-height: 0.34rem;
        text-align: center;
        font-size: 0.12rem;
        color: rgba(57, 75, 229, 1);
        font-weight: normal;
        position: relative;
        z-index: 10;

        ._brick {
          content: '';
          position: absolute;
          display: inline-block;
          width: 0.16rem;
          height: 0.16rem;
          transform: rotate(45deg);
          background-color: rgba(221, 232, 255, 1);
          top: -0.05rem;
          left: 0.8rem;
          z-index: -1;
          transition: left 300ms ease-out;

          &._brick-email {
            left: 2.4rem;
          }
        }
      }

      ._row {
        width: 100%;
        height: 0.46rem;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
        padding: 0 0.16rem;

        &._big {
          height: 0.58rem;
        }

        input[type='email'] {
          text-align: right;
          font-size: 0.12rem;
          color: rgba(144, 144, 144, 1);
          outline: none;
        }

        ._key {
          font-size: 0.14rem;
          color: rgba(55, 55, 55, 1);
        }

        ._value {
          font-size: 0.12rem;
          color: rgba(144, 144, 144, 1);
        }
      }
    }
  }

  .card-item {
    padding-bottom: 0.12rem;
    font-size: 0.14rem;
    color: #363636;
    letter-spacing: 0.82px;
    display: flex;
    align-items: center;

    ._left {
      flex-shrink: 0;
    }

    &:last-child {
      padding-bottom: 0.16rem;
    }

    &:first-child {
      padding-top: 0.16rem;
    }
  }

  #order-detail {
    padding-top: 0.16rem;
    min-height: 100vh;
    box-sizing: border-box;

    .order-header {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      padding: 0.16rem;

      .order-image-container {
        width: 0.52rem;
        height: 0.74rem;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .hun-image-container {
          width: 113px;
          height: 74px;
          flex-shrink: 0;
          margin-right: 8px;
          img {
              width: 100%;
              height: 100%;
              object-fit: cover;
          }
      }
      .order-info {
        width: calc(100% - 0.62rem);
        position: relative;
        padding-bottom: 0.22rem;
      }

      .info-line {
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        .spec-name {
          width: 100%;
          padding-right: 0.04rem;
        }

        .order-status {
          flex-shrink: 0;
        }
      }

      .save-btn {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 0.12rem;
        width: 0.8rem;
        height: 0.22rem;
      }
    }
  }

  .small-btn-container {
    display: flex;
    justify-content: flex-end;
    font-size: 0.12rem;
  }

  .card-title {
    font-size: 0.14rem;
    font-weight: bold;
    color: #363636;
    padding: 0.14rem 0;
    border-bottom: 1px solid rgba(151, 151, 151, 0.30);
    padding-left: 0.16rem;
  }

  .card-title-blue {
    color: #4455E4;
  }

  .card-body {
    padding-left: 0.16rem;
    padding-right: 0.16rem;
  }

  #package-info-detail {
    padding-top: 0.17rem;
  }

  .package-info-item {
    display: flex;
    position: relative;
    line-height: 0.2rem;
    font-size: 0.14rem;
    color: #B7B7B7;
    letter-spacing: 0.7px;

    &:first-child {
      color: #363636;

      .package-time {
        color: #363636;
      }

      .package-date {
        color: rgba(183, 183, 183, 1);
      }
    }

    &:last-child > .package-content-container {
      border-left: 1px solid white;
    }
  }

  .package-content-container {
    flex: 1;
    margin-left: 0.13rem;
    padding-left: 0.12rem;
    padding-bottom: 0.1rem;
    margin-bottom: 0.14rem;
    min-height: 0.5rem;
    border-left: calc(1px * 2) solid rgba(221, 221, 221, 0.5);
    position: relative;

    &::before {
      content: '';
      width: calc(1px * 4);
      height: calc(1px * 4);
      border-radius: 50%;
      background: #b7b7b7;
      position: absolute;
      display: inline-block;
      left: calc(-1px * 3);
      top: -0.08rem;
    }
  }

  .package-content {
    position: relative;
    font-size: 0.14rem;
    top: -0.14rem;
    word-break: break-all;
  }

  .package-datetime {
    position: relative;
    top: -0.14rem;

    .package-date {
      font-size: 0.12rem;
    }
  }


  .card-item-with-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.09rem;

    .left {
      flex-shrink: 0;
    }
  }

  .cp-btn {
    width: 0.56rem;
    height: 0.2rem;
    border-color: rgba(54, 54, 54, 0.7);
    color: rgba(54, 54, 54, 0.7);
    font-size: 0.12rem;
    border-radius: 2px;
    padding-top: 0;
  }


  .shipping-tip {
    font-size: 0.12rem;
    color: rgba(132, 132, 132, 1);
    position: relative;
    display: inline-block;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 0.18rem;
      height: 1px;
      top: 50%;
      background-color: rgba(132, 132, 132, 1);
    }

    &::before {
      left: -0.2rem;
    }

    &::after {
      right: -0.2rem;
    }
  }

  .package-time {
    text-align: right;
    font-size: 0.14rem;
    color: rgba(183, 183, 183, 1);
  }

  .package-data {
    text-align: right;
    font-size: 0.12rem;
    color: rgba(183, 183, 183, 1);
  }
  .savebtnp{
      width:3.43rem;
      height:.44rem;
      border-radius:.05rem;
      font-size: .16rem;
      background-color: #465AE0;
      color:#fff;
      display: flex;
      justify-content: center;
      align-items: center;
      position:fixed;
      bottom:.19rem;
      left:50%;
      transform: translateX(-50%);
      z-index:1;
  }
</style>
